import apiClient from "./client";

export const getProjects = async ({ language = "en" } = {}) => {
  const response = await apiClient.get("/projects", {
    params: { language },
  });
  return response.data;
};

export const getProjectById = async ({ id, language = "en" }) => {
  const response = await apiClient.get(`/projects/${id}`, {
    params: { language },
  });
  return response.data;
};
